<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';
  import TermsAndPrivacyAjax from '@ajax/terms_and_privacy';
  import Auth from '@utils/auth';
  import Log from '@utils/log';
  import { getCurrentUserStore } from '@stores/current_user';

  const dispatch = createEventDispatcher();

  export let mobile = false;

  let user = getCurrentUserStore('default');

  export let showModal = false;
  let termsAndPrivacy = { terms_url: '', privacy_url: '' };
  let saving = false;
  let showDeleteYourAccount = false;

  const close = function () {
    showModal = false;
    dispatch('close');
  };

  const accept = async function () {
    if (saving) {
      return;
    }

    saving = true;

    try {
      await TermsAndPrivacyAjax.accept();
      await Auth.load(user, user.api_token);
    } catch (err) {
      Log.info(`Unable to accept terms and service modal: ${err}`, true);
    }

    saving = false;
    close();
  };

  const reject = function () {
    showDeleteYourAccount = true;
  };

  const back = function () {
    showDeleteYourAccount = false;
  };

  const deleteAccount = async function () {
    if (saving) {
      return;
    }

    saving = true;
    await TermsAndPrivacyAjax.reject();
    saving = false;
    Auth.signout(user);
  };

  (async () => {
    try {
      termsAndPrivacy = await TermsAndPrivacyAjax.get();
    } catch {
      Log.info('Unable to load privacy & terms in frontend (in modal)', true);
    }
  })();
</script>

<style style="text/scss" lang="scss">
  .terms-container {
    text-align: center;

    .emoji-header {
      margin-top: 20px;
    }

    .terms-title {
      margin-top: 40px;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
    }

    .terms-desc {
      margin-top: 30px;
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      color: #7f7f7f;
      width: 512px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 25px;
      padding-right: 25px;

      a {
        color: #a893f9;
        font-weight: 700;

        &:hover {
          color: #7054dc;
        }
      }
    }

    .term-actions {
      margin-top: 64px;
      width: 180px;
      margin-left: auto;
      margin-right: auto;

      .reject-btn {
        margin-top: 22px;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      .back-btn {
        margin-top: 22px;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .mobile {
    .term-actions {
      width: 100%;
    }

    .terms-desc {
      width: 100%;
    }
  }

  * :global(.term-actions-delete button) {
    background: #ff5567;
    box-shadow: none;

    &:hover {
      background: #d04855;
    }
  }
</style>

{#if showModal}
  <div class="svelte-modal">
    <Modal
      mobile={mobile}
      on:close={close}
      show={showModal}
      showCloseButton={false}
      allowClose={false}
      fadeInDuration={200}
      style={mobile ? '' : 'border-radius: 16px; width: 660px;'}>
      <div class="terms-container" class:mobile={mobile} slot="content">
        <div style={showDeleteYourAccount ? '' : 'display: none;'}>
          <img class="emoji-header" src="/images/terms-and-privacy/delete.svg" />
          <div class="terms-title">Delete your account?</div>
          <div class="terms-desc">
            To continue using Benable you must accept the Terms of Service and Privacy Policy. Otherwise, you may delete
            your Benable account.
          </div>
          <div class="term-actions term-actions-delete">
            <Button
              text={saving
                ? '<i class="fa fa-spinner fa-spin"></i><span style="padding-left: 10px">Deleting</span>'
                : 'Delete account'}
              style="padding-top: 4px;"
              on:click={deleteAccount} />

            <div class="back-btn" on:click={back}>Back</div>
          </div>
        </div>
        <div style={showDeleteYourAccount ? 'display: none;' : ''}>
          <img class="emoji-header" src="/images/terms-and-privacy/bag.svg" />
          <div class="terms-title">New Terms of Service & Privacy Policy</div>
          <div class="terms-desc">
            Our <a
              on:click={() => window.open(termsAndPrivacy.terms_url)}
              href={termsAndPrivacy.terms_url}
              targe="_blank">Terms of Service</a>
            and
            <a
              on:click={() => window.open(termsAndPrivacy.privacy_url)}
              href={termsAndPrivacy.privacy_url}
              targe="_blank">Privacy Policy</a> have changed. By clicking accept, you agree that you have read and agreed
            to be bound by these new terms.
          </div>
          <div class="term-actions">
            <Button
              text={saving
                ? '<i class="fa fa-spinner fa-spin"></i><span style="padding-left: 10px">Saving</span>'
                : 'Accept'}
              style="padding-top: 4px;"
              on:click={accept} />

            <div class="reject-btn" on:click={reject}>Reject</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
{/if}
